import { render } from "./ProductReport.vue?vue&type=template&id=14801621&scoped=true"
import script from "./ProductReport.vue?vue&type=script&lang=js"
export * from "./ProductReport.vue?vue&type=script&lang=js"

import "./ProductReport.vue?vue&type=style&index=0&id=14801621&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-14801621"

export default script